<template>
  <div v-if="isThankYouVisible" class="form-overlay">
    <div v-if="isLoading" class="form-overlay__loader-wrapper">
      <LoaderSpinner cobalt />
    </div>
    <div
      v-show="!isLoading && isSuccess"
      id="overlay-content"
      class="form-overlay__content"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { scrollTo } from '@/utils/helpers'
const { windowWidth } = useResize()

interface Props {
  isLoading: boolean
  isSuccess: boolean
  isError: boolean | undefined
}

const props = defineProps<Props>()

watch(
  () => props.isSuccess,
  () => {
    if (props.isSuccess && windowWidth.value < 768) {
      setTimeout(() => {
        scrollTo('#overlay-content', 50)
      }, 100)
    }
  },
)

const isThankYouVisible = computed(() => {
  return (props.isLoading || props.isSuccess) && !props.isError
})
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideFromBottom {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-overlay {
  padding: 40px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  z-index: 1;

  &__loader-wrapper {
    animation: fadeIn 0.6s;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__content {
    animation: slideFromBottom 0.8s;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
</style>
